<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong>Reporte Pagos Por Usuario</strong>
          </CCardHeader>
          <CCardBody>

          <b-form id="Form" autocomplete="off" @submit.prevent="Validate">
            <b-row class="justify-content-center">

              <b-col lg="5">
                  <b-form-group>
                    <label>Cliente: </label>
                    <v-select @change="CreditSearchByClient" placeholder="Seleccione un cliente" class="w-100" :filterable="false" label="text" v-model="client" @search="SearchClients" :options="clients"></v-select>
                    <small v-if="errors.id_client" class="form-text text-danger" >Seleccione un cliente</small>
                  </b-form-group>
                </b-col>

                <b-col lg="2">
                  <b-form-group>
                    <label>Modalidad de Crédito: </label>
                    <b-form-select @change="CreditSearchByClient" placeholder=" Todos " class="w-100"  label="text" v-model="report.credit_plus"  :options="credit_plus"></b-form-select>
                  </b-form-group>
                </b-col>

                <b-col lg="2">
                  <b-form-group>
                    <label>Listado de Crédito: </label>
                    <b-form-select placeholder=" Todos " class="w-100"  label="text" v-model="report.id_credit" :options="credits"></b-form-select>
                  </b-form-group>
                </b-col>

    

                <b-col sm="12" md="1">
                  <b-form-group>
                    <label for="">.</label>
                    <b-button class="form-control" type="submit" variant="primary"><i class="fas fa-search"></i></b-button>
                  </b-form-group>
                </b-col>

                <b-col sm="12" md="1">
                  <b-form-group>
                    <label for="">.</label>
                    <b-button class="form-control" type="button" variant="success" @click="ExportExcel"><i class="fas fa-file-excel"></i></b-button>
                  </b-form-group>
                </b-col>

                <b-col sm="12" md="1">
                  <b-form-group>
                    <label for="">.</label>
                    <b-button class="form-control" type="button" variant="warning" @click="ExportPDF"><i class="fas fa-file-pdf"></i></b-button>
                  </b-form-group>
                </b-col>

                

            </b-row>
          </b-form>

          <div class="table-responsive mt-3">
            <table class="table table-hover table-bordered">
              <thead>
                <tr>
                  <th class="text-center">Cuota</th>
                  <th class="text-center">Fecha</th>
                  <th class="text-center">Documento</th>
                  <th class="text-center">Numero</th>
                  <th class="text-center">Capital</th>
                  <th class="text-center">Interes</th>
                  <th class="text-center">Mora</th>
                  <th class="text-center">Otros</th>
                  <th class="text-center">Flat</th>
                  <th class="text-center">Total</th>
                  <th></th>
                </tr>
              </thead>
              <tbody >
                <tr v-for="(item, it) in data_table" :key="it">
                  <td class="text-center">{{ item.number_quota }}</td>
                  <td class="text-center">{{ item.date }}</td>
                  <td class="text-LEFT">{{ item.type_invoice }}</td>
                  <td class="text-left">{{ item.number }}</td>
                  <td class="text-right">{{ item.capital }}</td>
                  <td class="text-right">{{ item.interest }}</td>
                  <td class="text-right">{{ item.delinquency }}</td>
                  <td class="text-right">{{ item.other_credit }}</td>
                  <td class="text-right">{{ item.administrative_process }}</td>
                  <td class="text-right">{{ item.total }}</td> 
                  <td class="text-center">
                    <b-button size="sm" title="Ver Crédito" variant="primary" @click="ViewCredit(item.id_credit)"><i class="fas fa-eye"></i></b-button>
                  </td> 
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="4" class="text-right">TOTAL</th>
                  <th class="text-right">{{ total.capital }}</th>
                  <th class="text-right">{{ total.interest }}</th>
                  <th class="text-right">{{ total.delinquency }}</th>
                  <th class="text-right">{{ total.other_credit }}</th>
                  <th class="text-right">{{ total.administrative_process }}</th>
                  <th class="text-right">{{ total.total }}</th> 
                  <th class="text-right"></th>
                </tr>

              </tfoot>
            </table>
          </div>

        
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <LoadingComponent :is-visible="isLoading"/>
  </div>
</template>

<style>
        table {
            width: 100%;
            border-collapse: collapse;
            overflow-x: auto; 
        }
    </style>

<script>
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";

const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";
import CodeToName from "@/assets/js/CodeToName";
var moment = require("moment");
import LoadingComponent from './../pages/Loading'

export default {
  name: "PaymentUser",
  props: {
    id_credit_url: {
      type: [String, Number],
      default: 0,
    },
  },
  components:{
    vSelect,
    LoadingComponent,
  },
  data() {
    return {
      isLoading: false,
      module: 'ReportPaymentUser',
      role:1,
      perPage: 15,
      currentPage: 1,
      rows: 0,
      data_table: [],
      total : {
        capital : '0.00',
        interest : '0.00',
        delinquency : '0.00',
        other_credit : '0.00',
        administrative_process : '0.00',
        total : '0.00',
      },
      report:{
        id_client:'all',
        credit_plus:'all',
        id_credit:'all'
      },

      client: null,
      clients: [],
      credit_plus: [
        {value:"all", text:"- Todos -"},
        {value:"0", text:"Normal"},
        {value:"1", text:"Plus"}
      ],
      credits: [
          {value:"all", text:"- Todos -"},
      ],

      users : [],
      user: null,
      credit_type:[],
      program_type:[],
      branch_office:[],
  
      errors:{
        id_client:false,
      }
    };
  },
  mounted() {
    this.InitParameters();
  },
  watch: {
    client(nuevoValor, valorAnterior){
      // console.log("El nombre pasó de ser %s a %s", valorAnterior, nuevoValor.value);
      this.CreditSearchByClient();
    } 
  },
  methods: {
    SearchClients,

    Validate,
    Report,
    ExportExcel,
    ExportPDF,
    CreditSearchByClient,
    ViewCredit,

    InitParameters,
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
    id_establishment: function () {
      let id_establishment = window.localStorage.getItem("id_establishment");
      id_establishment = JSON.parse(je.decrypt(id_establishment));
      return id_establishment;
    },
  },
};

function InitParameters() {
  if (this.id_credit_url) {
    let me = this;
  let url = me.url_base + "credit/view/"+this.id_credit_url;
  axios({
    method: "GET",
    url: url,
    headers: { "Content-Type": "application/json", token: me.token, module: me.module, role: me.role },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.client = { value: response.data.result.id_client, text: response.data.result.client_name };
        me.CreditSearchByClient();
        me.Report();

      } 
    });
  }
}

function ViewCredit(id_credit) {
  const url = this.$router.resolve({
    name: "CreditView",
    params: { id_credit: je.encrypt(id_credit) },
  }).href;
  window.open(url, '_blank');
}



function SearchClients(search, loading) {
  
  let me = this;
   let url = this.url_base + "client/search";
   if (search !== "") {

    let data = {
      search : search
    };

     loading(true);
     axios({
       method: "POST",
       url: url,
       data: data,
       headers: { "Content-Type": "application/json", token: me.token, module: me.module,role: me.role },
     }).then(function (response) {
           me.clients = response.data.result;
           loading(false);
     })
   }
}

function ExportExcel() {  
  let me = this;
  this.errors.id_client = this.client == null ? true : false;
  if (this.errors.id_client == true) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  me.report.id_client = me.client.value;
  let url = me.url_base + "excel/report-payment-user/"+me.report.id_client+"/"+me.report.credit_plus+"/"+me.report.id_credit;
  window.open(url,'_blank');
}

function ExportPDF() {
  
  let me = this;
  
  this.errors.id_client = this.client == null ? true : false;
  if (this.errors.id_client == true) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  me.report.id_client = me.client.value;
  let url = me.url_base + "pdf/report-payment-user/"+me.report.id_client+"/"+me.report.credit_plus+"/"+me.report.id_credit;
  window.open(url,'_blank');
}

function Validate() {

  this.errors.id_client = this.client == null ? true : false;
  if (this.errors.id_client == true) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  this.Report();
}


function Report() {
  let me = this;
  me.report.id_client = me.client == null ?  '':me.client.value;
  if (me.report.id_client.length == 0) {
    Swal.fire({ icon: 'warning', text: 'Seleccione un cliente', timer: 3000,})
     me.credits = [{value:'all', text:'- Todos - '}];
     return false;
  }
  // if (me.credits.length <= 1) {
  //   Swal.fire({ icon: 'warning', text: 'El cliente no cuenta con creditos', timer: 3000,})
  //    me.data_table = [];
  //    me.total =  {
  //       capital : '0.00',
  //       interest : '0.00',
  //       delinquency : '0.00',
  //       other_credit : '0.00',
  //       administrative_process : '0.00',
  //       total : '0.00',
  //     }
  //    return false;
  // }

  let data = me.report;
  let url = this.url_base + "report/payment-user";
  me.isLoading = true;
  axios({
    method: "POST",
    url: url,
    data: data,
    headers: { token: this.token, module: this.module, role: 1,},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.data_table = response.data.result.data_report;
        me.total = response.data.result.total;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
      me.isLoading = false;
    })
     .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      me.isLoading = false;
    });
}


function CreditSearchByClient() {
  let me = this;
  me.report.id_client = me.client == null ?  '':me.client.value;
  if (me.report.id_client.length == 0) {
    Swal.fire({ icon: 'warning', text: 'Seleccione un cliente', timer: 3000,})
     me.credits = [{value:'all', text:'- Todos - '}];
     return false;
  }
  let data = me.report;
  let url = this.url_base + "credit-search-by-client";
  // me.isLoading = true;
  axios({
    method: "POST",
    url: url,
    data: data,
    headers: { token: this.token, module: this.module, role: 1,},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.report.id_credit = 'all';
        me.credits = [...[{value:'all', text:'- Todos - '}],...response.data.result];
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
      // me.isLoading = false;
    })
     .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      // me.isLoading = false;
    });
}





</script>
